import React, { useState } from "react";
import DropdownList from "../../Patient/partial/DropdownList";

const NewSubscriptionForm = ({ onSubmit, onCancel, parents = [] }) => {
	const [sites, setSites] = useState([]);
	const [site, setSite] = useState(null);

	const amountRef = React.createRef();
	const currencyRef = React.createRef();
	const dayRef = React.createRef();
	const parentsList = parents.map(item => ({
		id: item.id,
		name: `${item.name} (${item.sites.length})`,
		sites: item.sites
	}));
	return (
		<form
			method="POST"
			onSubmit={event => {
				event.preventDefault();
				onSubmit({
					amount: parseInt(amountRef.current.value),
					days: parseInt(dayRef.current.value),
					currency: currencyRef.current.value,
					site: site.id
				});
				amountRef.current.value = "";
				dayRef.current.value = "";
				currencyRef.current.value = "";
			}}
		>
			<div className="form-row">
				<div className="col">
					<DropdownList
						items={parentsList}
						onSelect={item => setSites(item.sites)}
						title="Parent Site"
					/>
					<small className="form-text text-muted">
						Select Parent
					</small>
				</div>
				<div className="col">
					<DropdownList
						items={sites}
						onSelect={site => setSite(site)}
						title="Site"
					/>
					<small className="form-text text-muted">
						Select site/client
					</small>
				</div>
			</div>
			<div className="form-group">
				<label htmlFor="amount">Amount Paid</label>
				<input
					type="number"
					className="form-control input-height"
					id="amount"
					min="0"
					required
					ref={amountRef}
					aria-describedby="amount"
					placeholder="Enter amount"
				/>
				<small id="amount" className="form-text text-muted">
					Amount Paid by the site/client
				</small>
			</div>
			<div className="form-group">
				<label htmlFor="currency">Currency</label>
				<input
					type="text"
					className="form-control input-height"
					id="currency"
					required
					ref={currencyRef}
					aria-describedby="currency"
					placeholder="Enter currency"
				/>
				<small id="currency" className="form-text text-muted">
					The currency symbol of the site/client country
				</small>
			</div>
			<div className="form-group">
				<label htmlFor="days">How many days?</label>
				<input
					type="number"
					className="form-control input-height"
					id="days"
					min="28"
					required
					ref={dayRef}
					aria-describedby="days"
					placeholder="Enter days"
				/>
				<small id="days" className="form-text text-muted">
					How many days is the client paying for?
				</small>
			</div>
			<div className="text-center">
				<button
					type="button"
					onClick={onCancel}
					className="mdl-button mdl-button--raised mdl-js-ripple-effect m-l-10 margin-right-10 btn-circle btn-default"
				>
					<i className="material-icons text-danger">cancel</i> Cancel
				</button>

				<button
					type="submit"
					className="mdl-button mdl-button--raised mdl-js-ripple-effect m-l-10  btn-circle btn-success"
				>
					Submit <i className="material-icons">arrow_right_alt</i>
				</button>
			</div>
		</form>
	);
};

export default NewSubscriptionForm;
